import { DateTime } from 'luxon';

/**
 * Count the number of weekdays (Mon–Fri) in the inclusive range
 * between two Luxon DateTimes. Time-of-day is ignored; the dates
 * are normalized to the start of their calendar day in their current zones.
 *
 * Examples (inclusive):
 * - Wed → Tue (7 calendar days incl.) => 5 weekdays.
 * - Mon → Fri => 5 weekdays.
 * - Fri → Mon => 2 weekdays (Fri + Mon).
 * - Sat → Sun => 0 weekdays.
 *
 * @param {DateTime} start
 * @param {DateTime} end
 * @returns {number} count of weekdays in the inclusive range
 */
export function countWeekdaysInclusive(start, end) {
	if (!start?.isValid || !end?.isValid) {
		throw new Error('Invalid DateTime passed to countWeekdaysInclusive.');
	}

	// Normalize to calendar days (drop time; keep zone)
	let s = start.startOf('day');
	let e = end.startOf('day');

	// Ensure s <= e
	if (e < s) {
		const tmp = s;
		s = e;
		e = tmp;
	}

	// Total days inclusive
	const totalDays = Math.floor(e.diff(s, 'days').days) + 1;

	// Fast path: whole weeks
	const fullWeeks = Math.floor(totalDays / 7);
	let weekdays = fullWeeks * 5;

	// Remainder days: walk from start weekday
	let remainder = totalDays % 7;
	let wd = s.weekday; // Luxon: 1=Mon ... 7=Sun
	while (remainder > 0) {
		if (wd <= 5) weekdays++;
		wd++;
		if (wd === 8) wd = 1; // wrap to Monday
		remainder--;
	}

	return weekdays;
}